import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toCalendrier } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';

const Badge = ({ Titre, TitreLong, Couleur }) => (
    <span className={`badge badge-pill badge-copro ${Couleur} text-uppercase mr-3`} title={TitreLong}>
        {Titre}
    </span>
);

const LigneNews = (props) => {
    const {
        Act, DateSaisie, Objet, Util1,
    } = props;

    return (
        <Link
            to={{
                pathname: '/MaCopropriete/News/Message',
                state: { Mes: props, isNews: true },
            }}
        >
            <div className="list-group-item list-group-item-action">
                <div className="media">
                    <div className="text-center align-self-center">
                        <Badge Titre="News" Couleur="badge-news" />
                        <br />
                        {Act === 'NEWSCS' && <Badge Titre="CS" TitreLong="Conseil syndical" Couleur="badge-cs" />}
                    </div>
                    <div className="media-body text-truncate">
                        <strong>{toCalendrier(DateSaisie)}</strong>{/*  <span>{Util1.Nom}</span> */}
                        <br />
                        {Objet}
                    </div>
                </div>
            </div>
        </Link>
    );
};

const CardNews = ({ LsNews }) => {
    const lsNews = LsNews.slice(0, 5).map((news, i) => <LigneNews key={i} {...news} />);

    return (
        <Card Titre={CardNews.titleName}>
            {lsNews.length > 0 ? (
                <React.Fragment>
                    <div className="card-text list-group list-group-flush small mb-3">{lsNews}</div>
                    <Link to="/MaCopropriete/News" className="btn btn-outline-primary">
                        Voir les news
                    </Link>
                </React.Fragment>
            ) : (
                <p className="card-text">
                    <i>Il n&apos;y a pas de news pour cette copropriété.</i>
                </p>
            )}
        </Card>
    );
};
CardNews.displayName = 'CardNews';
CardNews.titleName = 'News';
CardNews.requiredProps = [
    'LsNews', // Liste des news
];

function mapStateToProps({
    CopStore: {
        Cop: { LsNews },
    },
}) {
    return { LsNews };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardNews));



// WEBPACK FOOTER //
// ./src/components/MaCopro/CardNews.js